module.exports = __webpack_public_path__ + "img/mao-na-massa.09f8ff72.jpg";